import { Component, OnInit, OnDestroy, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subject, takeUntil } from 'rxjs';
import { environment } from '@environments/environment';
import { SessionStorageService } from '@app/core/auth/session-storage';
import {
  TopBarComponent,
  TopBarItem,
  TopBarTitle,
} from '@app/shared/components/top-bar/top-bar';
import { removeHashQuery } from '@app/shared/utils/remove-hash-query/remove-hash-query';
import { WindowRef } from '@app/core/providers/window-ref';

@Component({
  selector: 'app-admin-layout',
  standalone: true,
  imports: [RouterOutlet, TopBarComponent],
  templateUrl: './admin-layout.html',
  styleUrls: ['./admin-layout.scss'],
})
export class AdminLayoutComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private isMobileSignal = signal(false);

  topBarItems: TopBarItem[] = [
    { name: 'account', text: ' / ' },
    { name: 'logout', text: 'ログアウト', action: () => this.onLogout() },
  ];
  topBarTitle: TopBarTitle = { text: '匿名化データレビュー管理画面' };

  constructor(
    private readonly sessionService: SessionStorageService,
    private readonly breakpointObserver: BreakpointObserver,
    private readonly windowRef: WindowRef,
  ) {}

  ngOnInit(): void {
    // パス付きでログインした場合、urlに認証情報が残ってしまうので除去
    removeHashQuery();

    this.breakpointObserver
      .observe(['(max-width: 1023px)'])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => this.isMobileSignal.set(result.matches));

    const userId = this.sessionService.getUserId();
    const userName = this.sessionService.getUserName();
    this.topBarItems = [
      { name: 'account', text: `${userName ?? ''} / ${userId}` },
      { name: 'logout', text: 'ログアウト', action: () => this.onLogout() },
    ];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isMobile(): boolean {
    return this.isMobileSignal();
  }

  onLogout(): void {
    this.sessionService.logout();
    this.windowRef.href = `${environment.cgwAuthWebUrl}?applicationCode=${environment.applicationName}#redirectUrl=${environment.baseUrl}`;
  }
}
